import React from "react";

import CommonModal from "../../Components/Modal";
import { getYouTubeEmbedUrl, isYouTubeUrl } from "../../Utils/Helper/videoUrl";

interface VideoPreviewModalProps {
  video: {
    title?: string | null;
    description?: string | null;
    video_url: string;
  } | null;
  onClose: () => void;
}

const VideoPreviewModal: React.FC<VideoPreviewModalProps> = ({
  video,
  onClose,
}) => {
  const embedUrl =
    video && isYouTubeUrl(video.video_url)
      ? getYouTubeEmbedUrl(video.video_url)
      : null;

  return (
    <CommonModal
      isOpen={!!video}
      toggle={onClose}
      title={video?.title || "Video Preview"}
      size="4xl"
      showHeader={true}
    >
      {video && (
        <div className="p-1">
          {video.description && (
            <p className="text-sm text-gray-600 mb-4">{video.description}</p>
          )}
          <div
            className="relative w-full rounded-lg overflow-hidden bg-black"
            style={{ aspectRatio: "16/9" }}
          >
            {embedUrl ? (
              <iframe
                className="absolute inset-0 w-full h-full"
                src={embedUrl}
                title={video.title || "Video"}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            ) : (
              <video
                className="w-full h-full object-contain"
                controls
                src={video.video_url}
                title={video.title || "Video"}
              >
                Your browser does not support the video tag.
              </video>
            )}
          </div>
        </div>
      )}
    </CommonModal>
  );
};

export default VideoPreviewModal;
